import React, { useState } from "react";

export const WeekContext = React.createContext({
  weekData: {
    monday: {},
    tuesday: {},
    wednesday: {},
    thursday: {},
    friday: {},
    saturday: {},
    sunday: {},
  },
  setWeekData: () => {},
  copiedDay: {
    monday: {},
    tuesday: {},
    wednesday: {},
    thursday: {},
    friday: {},
    saturday: {},
    sunday: {},
  },
  setCopiedDay: () => {},
});

export const WeekProvider = ({ children }) => {
  const [weekData, setWeekData] = useState([]);
  const [copiedDay, setCopiedDay] = useState(null);

  return (
    <WeekContext.Provider
      value={{ weekData, setWeekData, copiedDay, setCopiedDay }}
    >
      {children}
    </WeekContext.Provider>
  );
};
